import React, { memo, useCallback } from 'react';
import { Modal } from '@app/components';
import { ReplyForm } from 'forms';
import { Reply, Tender } from '@app/models';

interface ReplyModalProps {
  visible: boolean;
  tender: Tender | null;
  onClose: (reply?: Reply) => void;
}

function ReplyModal(props: ReplyModalProps) {
  const { visible, tender, onClose } = props;

  const closeModal = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Modal
      visible={visible}
      onClose={closeModal}
      title={`Откликнуться на ${tender ? tender.name : ''}`}
      size="large"
    >
      <ReplyForm tender={tender} onSubmit={onClose} />
    </Modal>
  );
}

export default memo(ReplyModal);
